module.exports = __webpack_public_path__ + "images/emoji/art.62b37b195a7b5d215568.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/art.png
// module id = 8cib
// module chunks = 2